export async function fetchJson<T>(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<T> {
  const res = await fetch(input, init)
  if (!res.ok) {
    throw new Error(`${res.status} ${res.statusText} — ${String(input)}`)
  }
  return (await res.json()) as T
}
